import React, { Component } from 'react'
import PropTypes from 'prop-types';

export default class CRUDForm extends Component{

  static propTypes = {
    match: PropTypes.object,
  }

  static errorStyle = {
    color: '#e23838',
    background: 'pink',
    padding: '15px 5px',
    borderLeft: '2px solid red'
  }

  get editMode(){
    return !!this.editId
  }

  get createMode(){
    return !this.editMode
  }

  get editId(){
    return this.props.match.params.editId
  }

  renderSubmissionErrors = () => {
    if(!this.state.submissionErrors.length)
      return

    return this.state.submissionErrors.map(({ detail,  source: { pointer }}, index) => {
      return (
        <p key={index} style={CRUDForm.errorStyle}>
          {`${pointer}`.replace(/.*\//, '')} {detail}
        </p>
      )
    })
  }

  componentDidMount = async () => {
    if(this.editMode){
      return this.loadEditItem && this.loadEditItem()
    }else{
      return this.loadCreateItem && this.loadCreateItem()
    }
  }

  onInputValueChange = (valueName) => ({ target: { value } }) => {
    this.setState({ [valueName]: value })
  }

  fieldErrors = (valueName) => {
    const helperText = this.state.errors[valueName]
    return { error: !!helperText, helperText }
  }

  nthValue = (n) => {
    return (...args) => {
      return args[n]
    }
  }

  requireFields = (requiredFields, errors={}) => {
    requiredFields.forEach(key => {
      if(!(this.state[key] || this[key]))
        errors[key] = 'This field is required'
    })
    return errors
  }

  render = () => false
}
